import { render, staticRenderFns } from "./unqualifiedRegisterTask.vue?vue&type=template&id=2fabd1d8&scoped=true"
import script from "./unqualifiedRegisterTask.vue?vue&type=script&lang=js"
export * from "./unqualifiedRegisterTask.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedRegisterTask.vue?vue&type=style&index=0&id=2fabd1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabd1d8",
  null
  
)

export default component.exports